 
 
 

function compare(a, b, dir) {
  if (dir === 'ASCENDING') {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
  }
  if (dir === 'DESCENDING') {
    if (a > b) return -1;
    if (a > b) return 1;
    return 0;
  }
}

export default (sourceArray, propertyName, direction) => {
  if (!sourceArray || !Array.isArray(sourceArray)) {
    //not an array
    return [];
  }

  if (propertyName === null) {
    //not array of objects
    return sourceArray.sort((elA, elB) => {
      if (isNaN(elA?.replace(',', '.')) || isNaN(elB?.replace(',', '.'))) {
        const dateA = Date.parse(elA);
        const dateB = Date.parse(elB);
        if (dateA && dateB) {
          return compare(dateA, dateB, direction);
        }
        if (typeof elA === 'string' && typeof elB === 'string') {
          return compare(elA.toUpperCase(), elB.toUpperCase(), direction);
        }
        return compare(elA, elB, direction);
      }
    });
  }

  return sourceArray.sort((elA, elB) => {
    //array of objects
    if (
      isNaN(elA[propertyName]?.replace(',', '.')) ||
      isNaN(elB[propertyName]?.replace(',', '.'))
    ) {
      const dateA = Date.parse(elA[propertyName]);
      const dateB = Date.parse(elB[propertyName]);
      if (dateA && dateB) {
        return compare(dateA, dateB, direction);
      }
      if (
        typeof elA[propertyName] === 'string' &&
        typeof elB[propertyName] === 'string'
      ) {
        return compare(
          elA[propertyName]?.toUpperCase(),
          elB[propertyName]?.toUpperCase(),
          direction
        );
      }
      return compare(elA[propertyName], elB[propertyName], direction);
    }
  });
};
